<template>
  <div ref="el" :data-simplebar="true">
    <slot />
  </div>
</template>

<script>
import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.min.css";

export default {
  name: "simplebar",
  mounted() {
    this.instance = new SimpleBar(this.$refs.el);
  },
  beforeUnmount() {
    if (this.instance) {
      this.instance.unMount();
      this.instance = null;
    }
  },
};
</script>
